export const sendWhatsAppMessage = (phone, message) => {
  const text = message.replaceAll('\n', '%0A');
  window.location = `https://wa.me/${phone}?text=${text}`;
};

export default {
  sendWhatsAppMessage,
};
